<template>
  <div
    class="list-view d-flex flex-column flex-grow-1"
    style="background-color: white; position: relative;"
  >
    <BackTop></BackTop>
    <div v-if="listStyle === 'inline'" class="d-flex flex-grow-1 flex-column">
      <v-list three-line flat class="py-0">
        <v-list-item-group>
          <v-list-item
            v-for="(item, index) in contentBriefs.moleculeItemVos"
            :key="index"
            @click="toDetail(item.id)"
            style="border-bottom: 1px solid #e8ebf0;"
          >
            <template v-slot:default>
              <v-list-item-action>
                <v-lazy>
                  <StructureViewer
                    :index="index"
                    :struct="{ data: item.data, format: item.type }"
                    :width="200"
                    :height="200"
                  />
                </v-lazy>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="pb-2">{{
                  item.title
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >{{ $i18n.t("formula") }} :
                  {{ item.title }}</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >{{ $i18n.t("mol_weight") }} :
                  {{ item.cp[1].value }}g/mol</v-list-item-subtitle
                >
                <v-list-item-subtitle
                  >{{ $i18n.t("complexity") }} :
                  {{ item.cp[0].value }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>

    <div v-else class="d-flex flex-column flex-grow-1">
      <v-row justify="center" align="center">
        <v-col
          sm="6"
          md="4"
          v-for="(item, index) in contentBriefs.moleculeItemVos"
          :key="index"
          @click="toDetail(item.id)"
          class="all-center"
          style="cursor: pointer;"
        >
          <v-card style="width: 200px;">
            <v-lazy style="width: 200px; height: 205px;">
              <StructureViewer
                :index="index + 100"
                :struct="{ data: item.data, format: item.type }"
                :width="200"
                :height="200"
              ></StructureViewer>
            </v-lazy>
            <div>
              <p
                style="
                  text-align: center;
                  white-space: normal;
                  font-size: 18px;
                "
              >
                {{ item.title }}
              </p>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-progress-linear
      indeterminate
      background-color="#f9f9f9"
      color="#999 "
      v-if="isLoading"
      class="mt-4 mb-4"
    >
    </v-progress-linear>
    <div
      v-if="showSearchImg"
      style="
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    >
      <div v-if="!noResults">
        <img
          src="../assets/searching.gif"
          style="width: 200px; height: 200px;"
          alt=""
        />
      </div>
      <div v-else>
        <img
          src="../assets/noResult.png"
          alt=""
          style="width: 200px; height: 200px;"
        />
        <div class="text-center">无搜索结果</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import StructureViewer from "./StructureViewer";

export default {
  name: "MoleList",
  data() {
    return {
      contentBriefs: {},
      currentPage: 1,
      noResults: false,
      showSearchImg: true,
      isLoading: false,
    };
  },
  components: {
    StructureViewer,
  },
  computed: {
    ...mapState(["briefs", "listStyle"]),
  },
  created() {},
  mounted() {
    let data = window.localStorage.getItem("moleConditions");
    this.molSearch(JSON.parse(data))
      .then((res) => {
        if (res.data.code === 701 || res.data.code === 702) {
          this.noResults = true;
        } else {
          this.contentBriefs = this.briefs;
          this.showSearchImg = false;
        }
      })
      .catch(() => {
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      });

    window.onscroll = () => {
      let scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        );
      if (clientHeight + scrollTop >= scrollHeight) {
        if (this.contentBriefs.total >= this.currentPage * 12) {
          this.isLoading = true;
          this.molSearch([{ type: "next", label: this.briefs.next }]).then(
            () => {
              this.isLoading = false;
              this.contentBriefs.moleculeItemVos = this.contentBriefs.moleculeItemVos.concat(
                this.briefs.moleculeItemVos
              );
              this.currentPage = this.currentPage + 1;
            }
          );
        }
      }
    };
  },
  methods: {
    ...mapMutations(["SET_LISTSTYLE"]),
    ...mapActions(["search", "getDetail", "molSearch"]),
    toDetail(id) {
      window.open(`#/detail?id=${id}`);
    },
    changeStyle(status) {
      this.SET_LISTSTYLE(status);
    },
  },
};
</script>

<style scoped></style>
